/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {CheckboxField} from 'helpers'
import {ColumnProps, IFormField} from 'models/Common'
import KTTable from 'helpers/ui-components/KTTable'
import {
 IReportingManager,
 IReportingManagerRes,
} from 'models/UserManagement'
import {
 fetchUserReportingOptions,
 submitUserReporting,
} from 'utils/api/auth/userManagementService'
import IAuth from 'models/Auth'
import {toast} from 'react-toastify'
import {KTUserLocation} from 'helpers/ui-components/KTUserLocation'
// import {ILogin} from 'models/Auth'
type IProps = {
 userId: string
 activeTabId: number
 loggedInUser: IAuth | undefined
 setLoader: (newState: boolean) => void
 handleTabClick: (
  newState: number,
  isBackBtnClick: boolean
 ) => void
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const HierarchyMapping = (props: IProps) => {
 const {t} = useTranslation()
 const [
  reportingManagerTableColList,
  setReportingManagerTableColList,
 ] = useState<Array<ColumnProps<IReportingManager>>>([])
 const [teamMemberTableColList, setTeamMemberTableColList] =
  useState<Array<ColumnProps<IReportingManager>>>([])
 const [teamMemberTableRows, setTeamMemberTableRows] =
  useState<IReportingManager[]>([])
 const [
  reportingManagerTableRows,
  setReportingManagerTableRows,
 ] = useState<IReportingManager[]>([])
 const {register, watch, handleSubmit} = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
 })

 const renderReportingManagerTableData = async () => {
  props.setLoader(true)

  const columns: Array<ColumnProps<IReportingManager>> = [
   {
    key: 'srNo',
    title: t(
     'userManagement.activate.reportingManagerMapping.srNo'
    ),
    className: 'w-[80px] text-center',
    isSrNo: true,
   },
   {
    key: 'full_name',
    title: t(
     'userManagement.activate.reportingManagerMapping.name'
    ),
   },
   {
    key: 'category',
    title: t(
     'userManagement.activate.reportingManagerMapping.role'
    ),
    className: 'w-[130px]',
   },
   {
    key: 'location',
    title: t(
     'userManagement.activate.reportingManagerMapping.location'
    ),
    render: (_, record) => {
     return (
      <KTUserLocation location={record?.geo_mapping} />
     )
    },
   },
   {
    key: 'phone_number',
    title: t(
     'userManagement.activate.reportingManagerMapping.contact'
    ),
    className: 'w-[100px]',
   },
   {
    key: 'status',
    title: t(
     'userManagement.activate.reportingManagerMapping.status'
    ),
    className: 'w-[80px]',
    render: (_, record) => {
     return record.is_active
      ? t(
         'userManagement.activate.reportingManagerMapping.active'
        )
      : t(
         'userManagement.activate.reportingManagerMapping.inActive'
        )
    },
   },
   {
    key: 'action',
    title: t(
     'userManagement.activate.reportingManagerMapping.action'
    ),
    className: '!text-center w-[140px]',
    render: (_, record) => {
     return (
      <div
       key={record?.id}
       className='w-full flex justify-center items-center'
      >
       <div
        className={`flex justify-center items-center w-[118px] h-12 rounded-lg border border-[#4E83E4] cursor-pointer text-[#4E83E4] font-semibold text-center
         shadow-[0_4px_4px_0_rgba(0, 0, 0, 0.12)] bg-white px-1 py-[3px]`}
       >
        <CheckboxField
         type='radio'
         disabled={false}
         label=''
         className={`activate-user-checkbox w-5 h-5 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 border-neutral-30`}
         wrapperClassName=''
         value={record.id}
         name={`reportingManagerUserId`}
         id={`reportingManagerUserId-${record.id}`}
         register={register(`reportingManagerUserId`, {
          required: false,
         })}
        />
        <span className={`text-base font-semibold ml-1`}>
         {watch(`reportingManagerUserId`) ===
         record.id.toString()
          ? t(
             'userManagement.activate.reportingManagerMapping.added'
            )
          : t(
             'userManagement.activate.reportingManagerMapping.add'
            )}
        </span>
       </div>
      </div>
     )
    },
   },
  ]
  setReportingManagerTableColList(columns)
  props.setLoader(false)
 }

 const renderTeamMemberTableData = async () => {
  props.setLoader(true)

  const columns: Array<ColumnProps<IReportingManager>> = [
   {
    key: 'srNo',
    title: t(
     'userManagement.activate.teamMemberMapping.srNo'
    ),
    className: 'w-[80px] text-center',
    isSrNo: true,
   },
   {
    key: 'full_name',
    title: t(
     'userManagement.activate.teamMemberMapping.name'
    ),
   },
   {
    key: 'category',
    title: t(
     'userManagement.activate.teamMemberMapping.role'
    ),
    className: 'w-[130px]',
   },
   {
    key: 'phone_number',
    title: t(
     'userManagement.activate.teamMemberMapping.contact'
    ),
    className: 'w-[100px]',
   },
   {
    key: 'currentlyReportingTo',
    title: t(
     'userManagement.activate.teamMemberMapping.currentlyReportingTo'
    ),
    className: 'w-[100px]',
   },
   {
    key: 'status',
    title: t(
     'userManagement.activate.teamMemberMapping.status'
    ),
    className: 'w-[80px]',
    render: (_, record) => {
     return record.is_active
      ? t(
         'userManagement.activate.teamMemberMapping.active'
        )
      : t(
         'userManagement.activate.teamMemberMapping.inActive'
        )
    },
   },
   {
    key: 'action',
    title: t(
     'userManagement.activate.teamMemberMapping.action'
    ),
    className: '!text-center w-[140px]',
    render: (_, record) => {
     return (
      <div
       key={record?.id}
       className='w-full flex justify-center items-center'
      >
       <div
        className={`flex justify-center items-center w-[118px] h-12 rounded-lg border border-[#4E83E4] cursor-pointer text-[#4E83E4] font-semibold text-center
         shadow-[0_4px_4px_0_rgba(0, 0, 0, 0.12)] bg-white px-1 py-[3px]`}
       >
        <CheckboxField
         type='checkbox'
         disabled={false}
         label=''
         className={`activate-user-checkbox w-5 h-5 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 border-neutral-30`}
         wrapperClassName=''
         value={record.id}
         name={`teamMemberUserIds`}
         id={`teamMemberUserIds-${record.id}`}
         register={register(`teamMemberUserIds`, {
          required: false,
         })}
        />
        <span className={`text-base font-semibold ml-1`}>
         {watch(`teamMemberUserIds`)?.length > 0 &&
         watch(`teamMemberUserIds`).includes(
          record.id.toString()
         )
          ? t(
             'userManagement.activate.teamMemberMapping.added'
            )
          : t(
             'userManagement.activate.teamMemberMapping.add'
            )}
        </span>
       </div>
      </div>
     )
    },
   },
  ]
  setTeamMemberTableColList(columns)
  props.setLoader(false)
 }

 const getReportingManager = async () => {
  props.setLoader(true)
  const res: IReportingManagerRes =
   await fetchUserReportingOptions(Number(props.userId))
  if (res?.reporting_managers) {
   setReportingManagerTableRows(res?.reporting_managers)
  }
  if (res?.reportees) {
   setTeamMemberTableRows(res?.reportees)
  }
  props.setLoader(false)
  await renderReportingManagerTableData()
  await renderTeamMemberTableData()
 }

 async function submitFormData(formData: IFormField) {
  if (
   formData?.reportingManagerUserId ||
   formData?.teamMemberUserIds?.length > 0
  ) {
   let res
   props.setLoader(true)
   const reporteeIds = formData?.teamMemberUserIds
    ? Array.isArray(formData.teamMemberUserIds)
      ? formData.teamMemberUserIds
      : [formData.teamMemberUserIds]
    : []
   if (formData?.reportingManagerUserId) {
    const payload = {
     reportee_ids: [props.userId],
     manager_id: formData.reportingManagerUserId,
    }
    console.log('payload manager', payload, formData)
    res = await submitUserReporting(payload)
   }
   if (reporteeIds.length > 0) {
    const payload = {
     reportee_ids: reporteeIds,
     manager_id: props.userId,
    }
    console.log('payload reportee', payload, formData)
    res = await submitUserReporting(payload)
   }
   if (res) {
    toast.success(res)
    props.handleTabClick(props.activeTabId, false)
   }
   props.setLoader(false)
  } else {
   toast.error(t('errors.pleaseSelectManager'))
  }
 }

 useEffect(() => {
  void getReportingManager()
 }, [])

 useEffect(() => {}, [reportingManagerTableRows])

 return (
  <>
   <div className='w-full'>
    <div className='text-[#171B1F] text-lg font-normal'>
     {t(
      'userManagement.activate.reportingManagerMapping.title'
     )}
    </div>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='w-full mt-6'>
      <KTTable
       data={reportingManagerTableRows}
       columns={reportingManagerTableColList}
       headerClass='bg-[#80868C]'
       headerColClass='!border-0 text-left'
       colClass='text-[#33393D] !text-sm font-normal !border-0'
       tableClass=''
       rowClass='even:bg-[#E6EBF0]'
       showPagination={false}
      />
     </div>
     <div className='w-full mt-10'>
      <div className='text-[#171B1F] text-lg font-normal'>
       {t(
        'userManagement.activate.teamMemberMapping.title'
       )}
      </div>
      <div className='w-full mt-6'>
       <KTTable
        data={teamMemberTableRows}
        columns={teamMemberTableColList}
        headerClass='bg-[#80868C]'
        headerColClass='!border-0 text-left'
        colClass='text-[#33393D] !text-sm font-normal !border-0'
        tableClass=''
        rowClass='even:bg-[#E6EBF0]'
        showPagination={false}
       />
      </div>
     </div>
     {(reportingManagerTableRows?.length > 0 ||
      teamMemberTableColList?.length > 0) && (
      <div className='w-full border-t border-[#E6EBF0] bg-white py-6'>
       <div className='flex items-center justify-end pr-[72px]'>
        <Button
         type='button'
         disabled={false}
         onClick={() => {
          props.handleTabClick(props.activeTabId, true)
         }}
         color='white'
         className='text-center py-[9px] px-6 bg-white 
                        !rounded-lg text-base text-[#4E83E4] hover:bg-[#4E83E4] font-semibold border-[#4E83E4] mr-2'
        >
         {t('userManagement.activate.back')}
        </Button>
        <Button
         type='submit'
         disabled={false}
         color='blue'
         className='text-center py-[9px] px-6 bg-[#4E83E4] 
                        !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
        >
         {t('userManagement.activate.saveNNext')}
        </Button>
       </div>
      </div>
     )}
    </form>
   </div>
  </>
 )
}

export default HierarchyMapping
